import * as React from 'react';

import { singleton } from 'logic/singleton';
import type { ReportingWidgetResult } from 'report/types';

const ReportRenderPageResults = React.createContext<Array<ReportingWidgetResult> | undefined>(undefined);

export default singleton('contexts.ReportRenderPageResults', () => ReportRenderPageResults);
